// Navigation helpers for handling redirects and reloads

export const handleExit = () => {
  window.location.href = "/";
};

export const handleReload = () => {
  location.replace("/w");
};
